var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"toggle-wrapper"},[(_vm.name)?_c('input',{attrs:{"type":"hidden","name":_vm.name},domProps:{"value":_vm.value}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"project-feature-toggle",class:{
      'is-checked': _vm.value,
      'is-disabled': _vm.disabledInput,
      'is-loading': _vm.isLoading
    },attrs:{"type":"button","aria-label":_vm.ariaLabel},on:{"click":_vm.toggleFeature}},[_c('loadingIcon',{staticClass:"loading-icon"}),_vm._v(" "),_c('span',{staticClass:"toggle-icon"},[_c('icon',{attrs:{"css-classes":"toggle-icon-svg","name":_vm.toggleIcon}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26c91d7c","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/toggle_button.vue
// module id = null
// module chunks = 